import section from './section/router'
import article from './article/router'

export default {
  routes: [
    ...section.routes,
    ...article.routes
  ]
}
